export default "__VITE_ASSET__bm0goT52__"